import { EventTypes } from 'redux-segment'
import { get } from 'lodash'

/**
 * Provide easier syntax for tracking redux actions with segment.
 *
 * To track an actions, provide a `track` key, with an object value
 * i.e. dispatch({ type: 'TRACK_ITEM', track: { itemId } })
 *
 * To identify a user, or add traits to a user, provide an `identify` key,
 * with an object value.  To specify a custom userId, add that to the value.
 * If omitted it will default to store.firebase.auth.uid
 * i.e. dispatch({ type: 'IDENTIFY_USER', identify: { name } })
 *
 * These keys can be combined
 */

const SegmentMiddleware = store => next => action => {
  // Skip if no tracking keys added
  if (!action.track && !action.identify) return next(action)

  // Build default meta object
  const meta = action.meta || {}

  if (!meta.analytics) {
    meta.analytics = []
  }

  // Add track calls to analytics
  if (action.track) {
    meta.analytics.push({
      eventType: EventTypes.track,
      eventPayload: { properties: action.track },
    })
  }

  // Add identify call to meta.analytics, inferring userId if not present
  if (action.identify) {
    let { userId, ...traits } = action.identify

    if (!userId) {
      userId = get(store.getState(), 'firebase.auth.uid')
    }

    meta.analytics.push({
      eventType: EventTypes.identify,
      eventPayload: { userId, traits },
    })
  }

  // Add the new meta object to action
  action.meta = meta

  // Return the propogation for testing purposes
  return next(action)
}

export default SegmentMiddleware



// WEBPACK FOOTER //
// ./src/reduxSegment.js